import { defineStore } from 'pinia';

export const useStore = defineStore('evacone-pwa', {
    state: () => {
        return {
            loggedInUsers: {},
            currentLocation: {},
            isAuthenticated: false,
            isProgressing: false,
            globalMessage: "",
            applicationVersion: "",
            selectedLanguage: "",
        }
    },
    getters: {
        getLoggedInUser: (state) => {
            // Get current location ID for the key — normalize to lowercase so
            // keys written by the API (lowercase UUIDs) match URL params (any case).
            const locationId = (state.currentLocation?.keyId || 'default').toLowerCase();
            const key = `${locationId}:loggedinuser`;
            return state.loggedInUsers[key] || null;
        },
        getLoggedInUserToken: (state) => {
            const locationId = (state.currentLocation?.keyId || 'default').toLowerCase();
            const key = `${locationId}:loggedinuser`;
            const user = state.loggedInUsers[key];
            if (user) {
                return user.token || "";
            }
            return "";
        },
        getCurrentLocation: (state) => {
            return state.currentLocation;
        },
        getSelectedLanguage: (state) => {
            return state.selectedLanguage || "";
        }
    },
    actions: {
        setIsProgressing(value) {
            this.isProgressing = value;
        },
        setLoggedInUser(value) {
            // Use provided locationId or current location — normalize to lowercase
            // so stored keys always match regardless of URL casing.
            const rawId = this.currentLocation?.keyId || 'default';
            const targetLocationId = rawId.toLowerCase();
            const key = `${targetLocationId}:loggedinuser`;

            if (value === null || value === undefined) {
                // Remove user for this location
                delete this.loggedInUsers[key];
            } else {
                // Set user for this location
                this.loggedInUsers[key] = value;
            }

            // Update isAuthenticated based on current location
            this.isAuthenticated = !!this.loggedInUsers[key];
        },
        setLoggedInLocation(value) {
            this.currentLocation = value;

            // Update isAuthenticated when location changes — normalize to lowercase
            if (value?.keyId) {
                const key = `${value.keyId.toLowerCase()}:loggedinuser`;
                this.isAuthenticated = !!this.loggedInUsers[key];
            } else {
                this.isAuthenticated = false;
            }
        },
        setGlobalMessage(value) {
            this.globalMessage = value;
        },
        setApplicationVersion(value) {
            this.applicationVersion = value;
        },
        setSelectedLanguage(value) {
            this.selectedLanguage = value || "";
        },
        setLocationParameters(params) {
            // Merge query-string parameters onto the current location object.
            // This keeps params in sync with whichever QR code was last scanned,
            // so re-scanning a different location automatically refreshes them.
            if (!this.currentLocation) return;
            this.currentLocation = {
                ...this.currentLocation,
                parameters: (params && Object.keys(params).length > 0) ? params : undefined,
            };
        },
    },
    persist: true,
}); 